export default class MandateReferenceNumberConfig {
    static fromData(data) {
        if (!data) {
            return;
        }

        let mandateReferenceNumberConfig = new MandateReferenceNumberConfig();
        mandateReferenceNumberConfig.prefix = data.prefix;

        return mandateReferenceNumberConfig;
    }
}
